import { FC, useRef, useState } from 'react'
import PageLayout from '../../../../../components/page-layout/page-layout'
import { Button, Flex } from 'antd'
import StampTubeLabel from '../../../../../components/stamp-tube-label/stamp-tube-label'
import { useReactToPrint } from 'react-to-print'
import styled from 'styled-components'
import WideSpace from '../../../../../components/wide-space/wide-space'
import { PrinterOutlined } from '@ant-design/icons'
import AddStampTubeLabel from '../../../../../components/stamp-tube-label/add-stamp-tube-label'
import Stamp from '../../../../../types/api/stamp'
import StampTubeLabelView from '../../../../../components/stamp-tube-label/stamp-tube-label-view'

const PdfPage = styled.div`
    position: relative;
    width: 29.7cm;
    /* height: 21cm; */
    /* border: 1px solid lightgray; */
    overflow: hidden;
    padding-left: 67px;
    padding-top: 70px;
`

interface LabelPrintingPageProps {}

const LabelPrintingPage: FC<LabelPrintingPageProps> = () => {
    const contentRef = useRef<HTMLDivElement>(null)
    const reactToPrintFn = useReactToPrint({
        contentRef,
    })

    const [labelIds, setLabelIds] = useState<number[]>([0])
    const [stamps, setStamps] = useState<{ [key: number]: Stamp | null }>({})

    const onAdd = () => {
        const newId = (labelIds.at(-1) || 0) + 1
        setLabelIds(state => [...state, newId])
    }

    const onRemove = (id: number) => {
        setLabelIds(state => state.filter(i => i !== id))
    }

    const onChange = (id: number, stamp: Stamp | null) => {
        setStamps(state => ({ ...state, [id]: stamp }))
    }

    return (
        <PageLayout title={'Печать метки штампа'}>
            <WideSpace size={48} align={'start'}>
                <PdfPage>
                    <Flex gap={30} wrap={'wrap'}>
                        {labelIds.map(id => {
                            return (
                                <StampTubeLabel
                                    onRemove={() => onRemove(id)}
                                    onChange={stamp => onChange(id, stamp)}
                                    key={id}
                                />
                            )
                        })}
                        {labelIds.length < 12 && <AddStampTubeLabel onClick={onAdd} />}
                    </Flex>
                </PdfPage>

                {/* Скрытый вывод для печати */}
                <div style={{ display: 'none' }}>
                    <PdfPage ref={contentRef}>
                        <Flex gap={30} wrap={'wrap'}>
                            {labelIds.map(id => {
                                return <StampTubeLabelView stamp={stamps[id]} key={id} />
                            })}
                        </Flex>
                    </PdfPage>
                </div>
                {/* ------------------------ */}

                <Button
                    type={'primary'}
                    icon={<PrinterOutlined />}
                    onClick={() => reactToPrintFn()}
                >
                    Печать
                </Button>
            </WideSpace>
        </PageLayout>
    )
}

export default LabelPrintingPage
